import { useEffect } from 'react';
import Treaser from './treaser';
import EfScrollAni from '@/efscrollani';

export default function SmartDevicesH5({ serverTime, ecoflowflag, ecoflowflag2, ecoflowflag3 }: any) {
    if (typeof window !== 'undefined') {
        window.AniContainer = new EfScrollAni();
    }

    useEffect(() => {
        return () => {
            AniContainer.destroy();
        };
    }, []);
    return <Treaser serverTime={serverTime} ecoflowflag={ecoflowflag} ecoflowflag2={ecoflowflag2} ecoflowflag3={ecoflowflag3} />;
}
